import './src/styles/tailwind.css';
import 'semantic-ui-css/semantic.min.css';
